<template>
  <v-container v-if="appointment" class="pa-0">
    <div>
      <h1>{{ dateFormatFriendly(appointment.date) }}</h1>
      <h3>{{ appointment.start_block.start }} - {{ appointment.end_block.end }}</h3>
      <p class="location" >{{ appointment.room.practice.name }} - {{ appointment.room.title }}</p>
      <p v-if="appointment.materialsHtml">{{appointment.materialsHtml}}</p>
    </div>
    <div class="appointments">
      <v-textarea
        outlined
        auto-grow
        filled
        clear-icon="mdi-close-circle"
        v-model="comment"
      ></v-textarea>

      <v-card-actions class="appt-actions justify-space-around" >
          <v-btn class="btn-confirm" @click="updateAppointment()" depressed>
            Wijzigingen opslaan
          </v-btn>

          <v-btn class="btn-delete" @click="deleteAppointment()" depressed>
            Verwijder {{ getTypeName }}
          </v-btn>
          
          <v-btn class="btn-prev" @click="$router.push({ name: 'my-appointments' })" depressed>
            Terug
          </v-btn>
      </v-card-actions>
    </div>
  </v-container>
</template>

<script>
import BackendService from "../services/BackendService"

export default {
  data: () => ({
    appointment: null,
  }),
  created() {
    const id = this.$route.params.id
    BackendService.getAppointment(id)
      .then((response) => {
        this.appointment = response.data;
        this.comment = response.data.comment;
      })
      .catch((err) => {
        console.log(err);
      })
  },
  computed: {
    getTypeName() {
      return (this.appointment.is_reservation) ? 'reservering' : 'afspraak'
    },
  },
  methods: {
    dateFormatFriendly(d) {
      return window.dateFormatFriendly(d);
    },
    deleteAppointment() {
      const id = this.$route.params.id
      BackendService.deleteAppointment(id)
      .then(() => {
        this.$router.push({ name: 'my-appointments' })
        this.$store.dispatch("notification/add", {
          type: "success",
          message: "Reservering verwijderd."
        });
      });
    },
    updateAppointment() {
      const id = this.$route.params.id
      let comment = this.comment
      BackendService.updateAppointment(id, { comment: comment })
      .then(() => {
        this.$router.push({ name: 'my-appointments' })
        this.$store.dispatch("notification/add", {
          type: "success",
          message: "Wijzigingen opgeslagen"
        });
      });
    }
  },
  filters: {
    formatDate: function(value) {
      if (value) {
        const parts = value.split(":");
        return +parts[0] + ":" + parts[1];
      } else {
        return null
      }
    }
  }
}
</script>

<style scoped>

.btn-confirm {
  background: #4caf50 !important;
  margin-left: 0px !important;
  color: #fff !important;
  font-weight: 800 !important;
  margin-bottom: 15px !important;
  text-transform: none !important;
  width: 100%;
}

.btn-delete {
  background: #ff5252 !important;
  margin-left: 0px !important;
  color: #fff !important;
  font-weight: 800 !important;
  margin-bottom: 15px !important;
  text-transform: none !important;
  width: 100%;
}

.btn-prev {
  background: #C0C0C0;
  border: 1px lightgray solid;
  margin-left: 0px !important;
  color: #fff;
  font-weight: 800 !important;
  text-transform: none !important;
  width: 100%;
}

</style>